// extracted by mini-css-extract-plugin
module.exports = {"share_btn":"Share_share_btn__x85E6","share_section":"Share_share_section__fXlhp","share_buttons":"Share_share_buttons__LSJjB","share_text":"Share_share_text__8prRc"};